import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { InsightOrderSearchModel } from "src/app/core/models/individual-model/individual-order-model/insight-order-search.model";
import { DateConverterService } from "src/app/core/utils/date-converter.service";
import { OrderSummaryView } from "../shared/views/order-summary-view";
import { InsightOrderService } from "src/app/core/services/individul-services/insight-order.service";
import { InsightProductTransportLocationModel } from "src/app/core/models/individual-model/individual-order-model/insight-product-transport-location.model";
import { OrderLocationSummaryView } from "../shared/views/order-location-summary-view";
import { OrdersMapperService } from "../shared/order-mapper.service";

@Component({
    selector: 'op-insight-sales-summary-summary',
    templateUrl: './insight-sales-summary-summary.component.html',
    providers: [
        OrdersMapperService
    ]
})
export class InsightSalesSummarySummaryComponent implements OnChanges {
    public orderSummaryView: OrderSummaryView;
    public focusing: boolean = false;
    public insightOrderLocationSummary: OrderLocationSummaryView;

    @Input() insightOrderSearchResults: InsightOrderSearchModel[];
    @Input() productAmount = 0;
    @Input() individualId: string;
    
    constructor(private dateConverterService: DateConverterService,
        private insightOrderService: InsightOrderService,
        private mapperService: OrdersMapperService,) 
    {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['insightOrderSearchResults']) {
            this.setOrderSummaryView();
            this.getInsightProductTransportLocations();
        }
    }

    private setOrderSummaryView() {
        let currency = "";
        let orderCount = 0;
        let sumAmount = 0;
        let sumPaidAmount = 0;
        let sumOutStandingBalance = 0;
        let lastOrder = "";
        
        if (this.insightOrderSearchResults?.length) {
            for(let result of this.insightOrderSearchResults) {
                currency = result.currencyCode;
                sumAmount += result.totalAmount;
                sumPaidAmount += result.paidAmount;
                sumOutStandingBalance += result.outstandingAmount;
                orderCount++;
            }
            
            lastOrder = this.dateConverterService.toDateFormat(this.insightOrderSearchResults[0].orderDate);
        }

        let avgAmount = orderCount == 0 ? orderCount : (sumAmount/orderCount);

        let view: OrderSummaryView = {
            currency: currency,
            totalAmount: sumAmount,
            totalPaidAmount: sumPaidAmount,
            totalOutStandingBalance: sumOutStandingBalance,
            numberOfOrders: orderCount,
            numberOfProducts: null,
            avgAmountPerOrder: avgAmount,
            lastOrder: lastOrder  
        }

        this.orderSummaryView = view;
    }

    private getInsightProductTransportLocations() {
        this.insightOrderService.searchInsightProductTransportLocations(this.individualId)
            .subscribe(
                (responses: InsightProductTransportLocationModel[]) => {
                    this.insightOrderLocationSummary = this.mapperService.toOrderLocationSummaryView(responses);
                },
            )
    }

    public getPaidAmountColor(orderSummaryView: OrderSummaryView): string {
        if (orderSummaryView?.totalAmount == orderSummaryView?.totalPaidAmount) {
            return 'paid-amount-fully-paid'
        }
        return '';
    }
    
    public getOutstandingBalanceColor(orderSummaryView: OrderSummaryView): string {
        if (orderSummaryView?.totalOutStandingBalance > 0) {
            return 'outstanding-amount';
        } else if (orderSummaryView?.totalOutStandingBalance < 0) {
            return 'outstanding-amount-refund'
        }
        return '';
    }

     protected formatDateTime(date: Date | string): string {
        return this.dateConverterService.formatSystemShortDate(date);
    }
}